import botIcon from '/src/assets/BotIcon.svg';
import arrowDown from '/src/assets/ArrowDown.svg';
import clsx from 'clsx';

export default function DropdownChatbot({isOpenChatbot, handlerClick, isFirstRenderChatbot}){
    
    return <>
    {isOpenChatbot ?
        <div id="bot-utn-dropdown-chatbot" onClick={handlerClick} className='bot-utn-open bot-utn-dropdown-open' >
          <img src={arrowDown} alt="Chatbot deployment icon"/>
        </div>
        :
        <div
            id="bot-utn-dropdown-chatbot"
            className={
                clsx(
                  {
                    'bot-utn-dropdown': isFirstRenderChatbot,
                    'bot-utn-first-dropdown': !isFirstRenderChatbot
                  },
                  'bot-utn-close'
            )}
            onClick={handlerClick}
        >
          <img src={botIcon} alt="Chatbot deployment icon"/>
        </div>
      }
    </>
}